module.exports = __webpack_public_path__ + "img/pdf_footer01.1373fb94.jpg";